import React from 'react';
import CommissionerOnlyGate from '../components/CommissionerOnlyGate';
import LoadingState from '../components/LoadingState';
import ScheduleSourcePanel from '../components/ScheduleSourcePanel';
import { useLeague } from '../hooks/useLeague';
import { isLeagueArchived } from '../lifecycle';

function ScheduleSourceSettingsContent() {
  const { league, loading, isOperator } = useLeague();

  if (loading) return <LoadingState />;
  if (!league) return null;
  if (!isOperator) {
    return (
      <div className="card text-sm text-secondary-300" data-testid="schedule-source-operator-only">
        Only league operators can manage the schedule source.
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="league-settings-schedule-source">
      <ScheduleSourcePanel
        leagueId={league.id}
        leagueArchived={isLeagueArchived(league.status)}
      />
    </div>
  );
}

const LscSettingsScheduleSourcePage: React.FC = () => (
  <CommissionerOnlyGate>
    <ScheduleSourceSettingsContent />
  </CommissionerOnlyGate>
);

export default LscSettingsScheduleSourcePage;
